

import {Component, Vue} from "vue-property-decorator";
import {TaskTuru} from "@/plugins/uyap-plugin/enum/TaskTuru";
import TopluGenelTalepHazirlaFormWizard
  from "@/components/forms/form-wizard/eicrapro/TopluGenelTalepHazirlaFormWizard.vue";
import UyapBagliDegilView from "@/views/eicrapro/UyapBagliDegilView.vue";

@Component({
  components: {UyapBagliDegilView, TopluGenelTalepHazirlaFormWizard}
})
export default class TopluGenelTalepHazirlaView extends Vue {
  taskTuru = TaskTuru;
}
